import React from "react";
import CV from "../../assets/sumit_kumar_resume.pdf";

const CTA = () => {
    return (
       <div className="cta">
           <a href={CV} download="Sumit_Kumar_Resume.pdf" className="btn mono">$ download_cv</a>
           <a href="#contact" className="btn btn-primary mono">$ contact --now</a>
       </div>
    )
}

export default CTA
